import React from "react";
import { Link, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import { StyledBreadcrumbs } from "./Breadcrumbs.style";
import { pushPathWithSearch } from "../../utilities/pushPathWithSearch";

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface AppBreadcrumbsProps {
  items: BreadcrumbItem[];
}

const getPharmacyBasePath = (pathname: string) => {
  return pathname.startsWith("/admin") ? "/admin/pharmacies" : "/pharmacies";
};

const AppBreadcrumbs: React.FC<AppBreadcrumbsProps> = ({ items }) => {
  const history = useHistory();

  const handleNavigate = (path?: string) => {
    if (!path) return;
    pushPathWithSearch(history, path);
  };

  return (
    <StyledBreadcrumbs aria-label="breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        if (isLast || !item.path) {
          return (
            <Typography key={index} fontWeight={600}>
              {item.label}
            </Typography>
          );
        }

        return (
          <Link
            key={index}
            underline="hover"
            color="inherit"
            component="button"
            onClick={() => handleNavigate(item.path)}
            sx={{ cursor: "pointer" }}
          >
            {item.label}
          </Link>
        );
      })}
    </StyledBreadcrumbs>
  );
};

export default AppBreadcrumbs;
